import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { setStep, goToPage, GetUserDetails, GetDetailsDeviceUpgrade, GetUserSignatureForm } from '../IdfSaleBlock/IdfSaleSlice';
import OrderSummaryPhoneUpgrade from '../IdfSaleBlock/SaleSteps/OrderSummaryPhoneUpgrade';
import GeneralError from '../IdfSaleBlock/Constans/GeneralError';
import Header from '../IdfSaleBlock/Constans/Header';
import Config from 'app/Config';
import useEffectAsync from 'app/utilities/hooks/useEffectAsync';
import EpiContext from "@episerver/spa-core/Spa";
import JoiningFormPopUp from '../IdfSaleBlock/PopUps/JoiningFormPopUp';
import PopUp from 'app/Components/Shared/Popup/PopUp';

const Icon = <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M18.25 21H4.75a.75.75 0 0 1-.75-.75V3.75A.75.75 0 0 1 4.75 3h9L19 8.25v12a.75.75 0 0 1-.75.75z" fill="#E0C1FF" stroke="var(--theme-primary, #810ea9)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
  <path d="M13.25 3v5.25h5.25M8 12.75h6M8 15.75h6" stroke="var(--theme-primary, #810ea9)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
</svg>

const IdfPresentationOfSignedFormsMain = (props) => {
  const [errorPage, setErrorPage] = useState(false);
  const [isShowJoiningPopUp, setIsShowJoiningPopUp] = useState(false);
  const store = props.idfStore

  useEffectAsync(async () => {
    if (props.auth.loginData?.isFullAuthenticated) {
      const res = await props.GetUserSignatureForm()
    }
  }, [props.auth?.loginData?.isFullAuthenticated]);


  const backToIdfSelfCare = () => {
    // props.context.navigateTo(props.iContent.idfSelfCareLink?.value);
    return EpiContext.navigateTo(Config.idfHomePageUrl);
  };

  return (
    <div className='signed-forms-main-container'>
      <Header onClickBack={() => backToIdfSelfCare()} />
      <span className='main-title'>טופס הצטרפות</span>
      <div className='idf-line'></div>
      <div className="links-container">
        <div className='link-container'>
          {Icon}
          <a href={props.iContent.informationSecurityForm.value} target='_blank' >טופס בטחון מידע</a>
        </div>
        <div className='link-container'>
          {Icon}
          <a href={props.iContent.cellularAuctionForm.value} target='_blank' >טופס עיקרי מכרז הסלולאר החדש</a>
        </div>
        <div className='link-container'>
          {Icon}
          <a onClick={() => setIsShowJoiningPopUp(true)} >טופס משפטי – הסדר מכשירי הטלפונים הניידים הצבאיים</a>
        </div>



      </div>
      <div className='idf-personal-info'>
        <PopUp preventWrapperClose={false} showPopUp={isShowJoiningPopUp} onClose={() => setIsShowJoiningPopUp(false)} className=''>
          <JoiningFormPopUp {...props} isDisabled={true} />
        </PopUp>
      </div>

      {errorPage && <GeneralError />}
    </div>
  );
};

const mapStateToProps = (state) => ({
  idfStore: state.idfSale,
  auth: state.authentication,
});

const mapDispatchToProps = {
  setStep,
  goToPage,
  GetUserDetails,
  GetDetailsDeviceUpgrade,
  GetUserSignatureForm,
};

export default connect(mapStateToProps, mapDispatchToProps)(IdfPresentationOfSignedFormsMain);
